import { render, staticRenderFns } from "./ProductMiniPreview.vue?vue&type=template&id=0871cbea&scoped=true&"
import script from "./ProductMiniPreview.vue?vue&type=script&lang=js&"
export * from "./ProductMiniPreview.vue?vue&type=script&lang=js&"
import style0 from "./ProductMiniPreview.vue?vue&type=style&index=0&id=0871cbea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0871cbea",
  null
  
)

export default component.exports